import { render } from "./FeedCommentContextMenu.vue?vue&type=template&id=a232aab4&ts=true"
import script from "./FeedCommentContextMenu.vue?vue&type=script&lang=ts"
export * from "./FeedCommentContextMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__